// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ovp-benefits-widget[data-v-5c2bdbec]{margin-bottom:10px}.ovp-benefits-widget-wrapper[data-v-5c2bdbec]{min-height:100px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
